import { render, staticRenderFns } from "./metafileds.vue?vue&type=template&id=5bca841c&scoped=true"
import script from "./metafileds.vue?vue&type=script&lang=js"
export * from "./metafileds.vue?vue&type=script&lang=js"
import style0 from "./metafileds.vue?vue&type=style&index=0&id=5bca841c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca841c",
  null
  
)

export default component.exports